var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 5,
    viewBox: "0 0 10 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.334672 0.666866C0.334368 0.511097 0.388618 0.36014 0.488005 0.240199C0.601037 0.103861 0.763673 0.0181003 0.940024 0.00184094C1.11638 -0.0144184 1.29195 0.0401596 1.42801 0.153532L5.00134 3.1402L8.58134 0.260199C8.71907 0.148352 8.8957 0.0960196 9.07213 0.114789C9.24855 0.133557 9.41022 0.221879 9.52134 0.360199C9.64403 0.499643 9.70299 0.68395 9.68401 0.868715C9.66502 1.05348 9.56982 1.22195 9.42134 1.33353L5.42134 4.55353C5.17534 4.75574 4.82067 4.75574 4.57467 4.55353L0.574672 1.2202C0.411041 1.08456 0.321894 0.879022 0.334672 0.666866Z",
    fill: "#637381"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown2);
export default __webpack_public_path__ + "static/media/Arrow-Down2.fa8d7cc26e3064c477e500b53ccdae0f.svg";
export { ForwardRef as ReactComponent };